import { createContext, useMemo, useRef } from 'react';
import { Provider } from 'urql';
import { createUrqlClient } from './createUrqlClient';
import { useMsalAccessToken } from 'auth/useMsalAccessToken';

interface UrqlProviderProps {
  children: React.ReactNode;
}

export interface LastExecutedQueries {
  [queryName: string]: string;
}

export const LastQueriesContext = createContext<LastExecutedQueries>({});

export const UrqlProvider: React.FC<UrqlProviderProps> = ({ children }) => {
  const { accessToken } = useMsalAccessToken();
  const lastExecutedQueriesRef = useRef<LastExecutedQueries>({});

  const memoizedCustomFetch = useMemo(() => {
    return (input: RequestInfo | URL, init?: RequestInit) => {
      const queryName = /(?<="operationName":")[^"]+/.exec(init?.body as string)?.at(0);

      if (queryName) {
        lastExecutedQueriesRef.current[queryName] = init?.body?.toString() as string;
      }
      return fetch(input, init);
    };
  }, [lastExecutedQueriesRef]);

  if (!accessToken) {
    return <></>;
  }

  return (
    <LastQueriesContext.Provider value={lastExecutedQueriesRef.current}>
      <Provider value={createUrqlClient(accessToken, memoizedCustomFetch)}>{children}</Provider>
    </LastQueriesContext.Provider>
  );
};
